// Inside Claude, the screen at "/" instead of the login form. A session ends
// when Tier B answers 401 (the connector could not refresh it); signing in again
// happens in Claude, by reconnecting the connector, never in this frame.

import { Box, Typography } from '@mui/material';

export default function EmbedSessionEnded() {
  return (
    <Box sx={{ px: 4, pt: 14, textAlign: 'center' }}>
      <Typography variant="h6" gutterBottom>
        Your Beiing Human session has ended
      </Typography>
      <Typography variant="body2">
        Reconnect the Beiing Human connector in Claude, then open Beiing Human again.
      </Typography>
    </Box>
  );
}
